import * as React from 'react';
import { ICoachCounts } from '@nkr/store/microsites/hooks/use-coach-counts';
import { todoStyles } from './styles';

interface IProps {
    counts: ICoachCounts;
}

const todoItems = [
    { label: 'New Assignments', countKey: 'newAssignments', path: '/microsite/coach/new-assignments' },
    { label: 'Pending Approval', countKey: 'pendingApproval', path: '/microsite/coach/approval' },
    { label: 'Pending Follow Up', countKey: 'pendingFollowUp', path: '/microsite/coach/to-do' },
    { label: 'Declined Custom Sites', countKey: 'declinedCs', path: '/microsite/coach/declined-cs' },
];

const TodoPanel: React.FC<IProps> = ({ counts }) => {
    const [expanded, setExpanded] = React.useState<boolean>(true);

    const total = todoItems.reduce((sum, item) => sum + (counts[item.countKey] || 0), 0);

    return (
        <div style={todoStyles.wrapper}>
            <div style={todoStyles.header} onClick={() => setExpanded(!expanded)}>
                TO-DO ({total}) {expanded ? '▾' : '▸'}
            </div>
            <div style={todoStyles.panel}>
                {expanded && (
                    <div style={todoStyles.body}>
                        {todoItems.map(item => (
                            <a key={item.path} href={item.path} style={todoStyles.row}>
                                <span style={todoStyles.badge}>{counts[item.countKey] || 0}</span>
                                {item.label}
                            </a>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default TodoPanel;
